const ITEMS = ["Hotel Canino", "Creche Canina", "Treinos", "Criação de Pastor Alemão", "Banhos & Tosquias", "Palmeira · Braga"];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="editorial-marquee" className="relative overflow-hidden border-y border-white/10 bg-[#08090B] py-7 sm:py-9">
      <div className="flex w-max animate-marquee">
        {row.map((t, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className={i % 2 ? "font-serif text-4xl italic text-[#C8D484] sm:text-6xl" : "font-display text-4xl font-medium uppercase tracking-[0.04em] text-white sm:text-6xl"}>
              {t}
            </span>
            <span className="mx-8 inline-block h-2 w-2 rounded-full bg-[#C8D484] sm:mx-14" />
          </span>
        ))}
      </div>
    </section>
  );
};
